import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { BaseControlProps } from '../../../types/controls';

import styles from './styles.module.css';

interface Props extends BaseControlProps {
    className?: string;
}

export const NextEpisodeButton: FC<Props> = ({ className, onClick }) => {
    const intl = useIntl();

    return (
        <button
            aria-label={intl.formatMessage({
                id: 'features.player.09ae1555da2b68862f3842de422ad585',
                defaultMessage: 'Go to the next episode',
                description: 'Ариа атрибут для кнопки перехода к следующему эпизоду',
            })}
            onClick={() => onClick?.()}
            className={classnames(styles.root, className)}
        />
    );
};
